<script>
export default {
  name: 'ToutiaoV3Default'
}
</script>

<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Tabs value="toutiaov3project">
        <TabPane name="toutiaov3project" label="项目"></TabPane>
      </Tabs>
      <div class="c-content">
        <keep-alive :max="10">
          <router-view />
        </keep-alive>
      </div>
    </Content>
  </Layout>
</template>
